// src/components/DeleteSelectionGroupModal/DeleteSelectionGroupModal.tsx

import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { RemoveOptionFromModifier } from '../../../../../../../../../../crud/menu_api/selection_modifiers';
import { toast } from 'react-toastify';

interface Modifier {
    modifier_id: number;
    modifier_name: string;
    modifier_description?: string;
    local_id: number;
}

interface ModifierOption {
    option_id: number;
    modifier_id: number;
    option_name: string;
    option_description?: string;
    price_modifier: number;
}

interface ItemModifier {
    item_id: number;
    modifier_id: number;
    is_optional: number;
    is_price_setter: number;
}
interface RemoveOptionFromModifierModalProps {
  show: boolean;
  handleClose: () => void;
  mod: Modifier;
  option:any;
  setOptions: (data: ModifierOption[]) => void;
  options: ModifierOption[];
}


const RemoveOptionFromModifierModal: React.FC<RemoveOptionFromModifierModalProps> = ({
  show,
  handleClose,
  mod,
  option,
  setOptions,
  options,
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleDelete = () => {
    setLoading(true);
    RemoveOptionFromModifier(mod.modifier_id, option.option_id)
      .then((response) => {
        toast.success('Grupo de selección eliminado exitosamente.');
        // Filtrar el grupo eliminado de la lista
        const updatedData = options.filter(
          (opt) => opt.option_id !== option.option_id
        );
        setOptions(updatedData);
        handleClose();
      })
      .catch((error) => {
        console.error('Error eliminando el grupo de selección', error);
        const message =
          error.response?.data?.message || 'Error al eliminar el grupo de selección.';
        toast.error(message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header >
        <Modal.Title>Eliminar Grupo de Selección</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          ¿Estás seguro de que deseas remover a {option.option_name} del grupo de modificadores{' '}
          <strong>{mod.modifier_name}</strong>?
        </p>
        
        <p>
          Esta acción no se puede deshacer
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={handleDelete} disabled={loading}>
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{' '}
              Eliminando...
            </>
          ) : (
            'Eliminar'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveOptionFromModifierModal;
